import axios from '../lib/AxApi';

export default
{
    async getTranslationByLangCode(langCode)
    {
        try
        {
            const response = await axios.get('/Translator/getTranslationByLangCode',
                {
                    params:
                    {
                        langCode,
                    },
                });
            return response.data;
        }
        catch (e)
        {
            return {
                error: true,
                notice: e.toString(),
            };
        }
    },
    async authenticateToken(params)
    {
        try
        {
            const response = await axios.get('/Session/authenticateToken',
                {
                    params,
                });
            return response.data;
        }
        catch (e)
        {
            return {
                error: true,
                notice: e.toString(),
            };
        }
    },
    async payoutToOnlineAccount(params)
    {
        try
        {
            const response = await axios.get('/Player/payoutToOnlineAccount',
                {
                    params,
                });
            return response.data;
        }
        catch (e)
        {
            return {
                error: true,
                notice: e.toString(),
            };
        }
    },
};
